import React from "react";
import { Form, Select, Input } from "antd";
import { capitalizeStringAccordingToNAValues } from "helpers/utils";

const RenderFilterFields = ({ filtersData, onFieldChange }) => {
  const handleChange = (value, filterCode) => {
    onFieldChange(filterCode, value);
  };

  return filtersData.map((filter) => {
    switch (filter.filter_type) {
      case "code_name_spinner":
        // Sort options for reporting_manager in ascending order
        const sortedOptions =
          filter.filter_code === "reporting_manager"
            ? filter.filter_values.sort((a, b) =>
                a.value.localeCompare(b.value)
              )
            : filter.filter_values;
        return (
          <Form.Item
            key={filter.filter_code}
            label={filter.filter_title}
            name={filter.filter_code}
          >
            <Select
              allowClear
              mode={filter.is_single_select ? undefined : 'multiple'}
              options={sortedOptions.map(val => ({
                label: capitalizeStringAccordingToNAValues(val.value),
                value: val.value,
                key: `${val.code}`,
              }))}
              placeholder={`Select ${filter.filter_title}`}
              onChange={(value) => handleChange(value, filter.filter_code)}
            />
          </Form.Item>
        );

      case "text":
        return (
          <Form.Item
            key={filter.filter_code}
            name={filter.filter_code}
            label={filter.filter_title}
          >
            <Input
              placeholder={`Enter ${filter.filter_title}`}
              onChange={(e) => handleChange(e.target.value, filter.filter_code)}
            />
          </Form.Item>
        );

      default:
        return null;
    }
  });
};

export default RenderFilterFields;
